import { render, staticRenderFns } from "./ErrorReport.vue?vue&type=template&id=e987d3d2&scoped=true"
import script from "./ErrorReport.vue?vue&type=script&lang=js"
export * from "./ErrorReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e987d3d2",
  null
  
)

export default component.exports